import { getInitialState } from './state';

const mutations = {
  SET_CLEAR_MODAL(state) {
    Object.assign(state, getInitialState());
  },
  SET_MODAL_DISPLAY(state, modalDisplay) {
    state.data.modalDisplay = modalDisplay;
  },
  SET_CSAT_DISPLAY(state, csatDisplay) {
    state.data.csat.display = csatDisplay;
  },
  SET_CSAT_SUBMITTED(state, submitted) {
    state.data.csat.submitted = submitted;
  },
};

export default mutations;
